/* eslint-disable max-len */
export default {
  ACTIONS: {
    BACK: 'Indietro',
    SCAN_QR_CODE: 'Leggere codice QR'
  },
  ERRORS: {
    GET_DOCUMENT: 'Non è stato possibile ottenere il documento.',
    INVALID_CODE: 'Codice non valido.',
    VALIDATING_CODE: 'Non è stato possibile convalidare il codice.'
  },
  LABELS: {
    DELIVERY_ORDER: 'Ordine di consegna',
    ERROR: 'Errore',
    OR: 'O',
    PACKAGE: 'Pacco',
    TRACKING_OR_CODE: 'Numero di tracciamento o codice del pacco'
  }
};
